/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateBinderClaimDetailDto } from './UpdateBinderClaimDetailDto';
import {
    UpdateBinderClaimDetailDtoFromJSON,
    UpdateBinderClaimDetailDtoFromJSONTyped,
    UpdateBinderClaimDetailDtoToJSON,
    UpdateBinderClaimDetailDtoToJSONTyped,
} from './UpdateBinderClaimDetailDto';

/**
 * 
 * @export
 * @interface UpdateBinderClaimPayloadDto
 */
export interface UpdateBinderClaimPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    claimsHandler?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    claimStatus?: UpdateBinderClaimPayloadDtoClaimStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    referenceNo?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateBinderClaimPayloadDto
     */
    dateReported?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateBinderClaimPayloadDto
     */
    dateOfLoss?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    catCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    causeOfLoss?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    lossLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    lossDescription?: string;
    /**
     * 
     * @type {Array<UpdateBinderClaimDetailDto>}
     * @memberof UpdateBinderClaimPayloadDto
     */
    binderClaimDetails?: Array<UpdateBinderClaimDetailDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    commentsTo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimPayloadDto
     */
    comments?: string;
}


/**
 * @export
 */
export const UpdateBinderClaimPayloadDtoClaimStatusEnum = {
    PreCautionary: 'Pre-cautionary',
    Registered: 'Registered',
    InProgress: 'In-progress',
    Closed: 'Closed'
} as const;
export type UpdateBinderClaimPayloadDtoClaimStatusEnum = typeof UpdateBinderClaimPayloadDtoClaimStatusEnum[keyof typeof UpdateBinderClaimPayloadDtoClaimStatusEnum];


/**
 * Check if a given object implements the UpdateBinderClaimPayloadDto interface.
 */
export function instanceOfUpdateBinderClaimPayloadDto(value: object): value is UpdateBinderClaimPayloadDto {
    return true;
}

export function UpdateBinderClaimPayloadDtoFromJSON(json: any): UpdateBinderClaimPayloadDto {
    return UpdateBinderClaimPayloadDtoFromJSONTyped(json, false);
}

export function UpdateBinderClaimPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBinderClaimPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claimsHandler': json['claimsHandler'] == null ? undefined : json['claimsHandler'],
        'claimStatus': json['claimStatus'] == null ? undefined : json['claimStatus'],
        'referenceNo': json['referenceNo'] == null ? undefined : json['referenceNo'],
        'dateReported': json['dateReported'] == null ? undefined : (new Date(json['dateReported'])),
        'dateOfLoss': json['dateOfLoss'] == null ? undefined : (new Date(json['dateOfLoss'])),
        'catCode': json['catCode'] == null ? undefined : json['catCode'],
        'causeOfLoss': json['causeOfLoss'] == null ? undefined : json['causeOfLoss'],
        'lossLocation': json['lossLocation'] == null ? undefined : json['lossLocation'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'lossDescription': json['lossDescription'] == null ? undefined : json['lossDescription'],
        'binderClaimDetails': json['binderClaimDetails'] == null ? undefined : ((json['binderClaimDetails'] as Array<any>).map(UpdateBinderClaimDetailDtoFromJSON)),
        'commentsTo': json['commentsTo'] == null ? undefined : json['commentsTo'],
        'comments': json['comments'] == null ? undefined : json['comments'],
    };
}

export function UpdateBinderClaimPayloadDtoToJSON(json: any): UpdateBinderClaimPayloadDto {
    return UpdateBinderClaimPayloadDtoToJSONTyped(json, false);
}

export function UpdateBinderClaimPayloadDtoToJSONTyped(value?: UpdateBinderClaimPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimsHandler': value['claimsHandler'],
        'claimStatus': value['claimStatus'],
        'referenceNo': value['referenceNo'],
        'dateReported': value['dateReported'] == null ? undefined : ((value['dateReported']).toISOString()),
        'dateOfLoss': value['dateOfLoss'] == null ? undefined : ((value['dateOfLoss']).toISOString()),
        'catCode': value['catCode'],
        'causeOfLoss': value['causeOfLoss'],
        'lossLocation': value['lossLocation'],
        'city': value['city'],
        'country': value['country'],
        'lossDescription': value['lossDescription'],
        'binderClaimDetails': value['binderClaimDetails'] == null ? undefined : ((value['binderClaimDetails'] as Array<any>).map(UpdateBinderClaimDetailDtoToJSON)),
        'commentsTo': value['commentsTo'],
        'comments': value['comments'],
    };
}

